import { render, staticRenderFns } from "./FbLikert.vue?vue&type=template&id=a7b445c2&scoped=true"
import script from "./FbLikert.vue?vue&type=script&lang=js"
export * from "./FbLikert.vue?vue&type=script&lang=js"
import style0 from "./FbLikert.vue?vue&type=style&index=0&id=a7b445c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b445c2",
  null
  
)

export default component.exports